import { render, staticRenderFns } from "./shopWallet.vue?vue&type=template&id=84cd5ca0&scoped=true&"
import script from "./shopWallet.vue?vue&type=script&lang=js&"
export * from "./shopWallet.vue?vue&type=script&lang=js&"
import style0 from "./shopWallet.vue?vue&type=style&index=0&id=84cd5ca0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cd5ca0",
  null
  
)

export default component.exports